export default "__VITE_ASSET__CbJ$f17___"